<template>
  <div class="page-detail">
    <div class="page-bg"></div>
    <div class="page-banner">
      <div class="page-banner-content">
        <div class="content-left">
          <div class="left-img" :class="{'note-img': dataInfo.try_stage === '第 27 期'}"
               :id="'detail-banner-img-'+ dataInfo.id">
            <img :src="dataInfo.banner_pic" alt=""/>
          </div>
        </div>
        <div class="content-right">
          <template v-if="state == 'end'">
            <div class="page-title page-title-70 page-title-right">
              <img src="@/assets/img/page-detail-title1.png" alt="">
            </div>
          </template>
          <template v-if="state == 'ing'">
            <div class="page-title">
              <img src="@/assets/img/page-detail-title.png" alt="">
            </div>
            <div class="right-last-con">
              <div class="right-last-title">剩余时间</div>
              <div class="right-last-time">
                <div class="time-one" v-for="(item,index) in countDownDatas" :key="index">
                  <p class="num">{{ item.value }}</p>
                  <span v-if="index === 0"></span>
                  <p :class="{num: index === 0}">{{ item.name }}</p>
                  <span v-if="index === 0"></span>
                </div>
              </div>
            </div>
            <div class="lijishenqing" @click.prevent="showQrCode()">申请试用></div>
          </template>
          <template v-if="state == 'start'">
            <div class="page-title">
              <img src="@/assets/img/page-detail-title.png" alt="">
            </div>
            <div class="right-last-con">
              <div class="right-last-title">开始时间</div>
              <div class="right-last-time">
                <div class="time-one" v-for="(item,index) in countDownDatasStart" :key="index">
                  <span v-if="index > 0"></span>
                  <p class="num start-num">{{ item.value }}</p>
                  <span></span>
                  <p class="num start-num">{{ item.name }}</p>
                </div>
              </div>
            </div>
            <div class="lijishenqing lijishenqing-no" @click="showQrCode">预约提醒></div>
          </template>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="container">
        <div class="content-title" :style="nextStyle">
          <div class="number-con">
            <div class="current-con">
              {{ dataInfo.try_stage }}&nbsp;&nbsp;&nbsp;&nbsp;
              <template v-if="state == 'end'">
                <span class="status-text">已结束</span>
              </template>
              <template v-if="state == 'ing'">
                <span class="status-text">火热进行中</span>
                <span class="icon-huo"></span>
              </template>
              <template v-if="state == 'start'">
                <span class="status-text">即将开始</span>
              </template>
            </div>
            <div class="next-con" @click.stop="clickNext()" v-if="nextText">
              {{ nextText }}
            </div>
          </div>
          <div class="content-box">
            <div class="title-describe">
              <h3 class="title">{{ dataInfo.try_title }}</h3>
              <h4 class="subtitle" v-html="dataInfo.try_subtitle"></h4>
            </div>
            <div class="price-number">
              <div class="price">￥<p>0</p><span class="old">￥{{ dataInfo.try_price }}</span></div>
              <div class="number">共{{ totalNum }}份 {{ applyNum }}人申请</div>
            </div>
          </div>
        </div>
        <div class="content-main">
          <div class="main">
            <div class="right-last-coupon" v-if="hasCoupon">
              <p class="right-last-coupon-infor">申请试用还可获得{{ couponTitle }}</p>
              <img class="coupon" :src="couponImg" alt="">
            </div>
            <div class="luck-container" v-if="false" style="padding-bottom: 0.2rem;">
              <div class="title">试用名单</div>
              <div v-for="item in selected" :key="'sel'+item.id">
                <div class="applyItem luck-list">
                  <img :src="item.avatar || require('@/assets/avatar-img.png')" class="portrait">
                  <div class="itemMiddle">
                    <span class="bold fontSize2">{{ item.nickname }}</span>
                    <span class="fontSize3 text-3"
                          style="margin-top: 0.028947rem; color: #595959;">{{ item.reason }}</span>
                  </div>
                  <div class="itemRight">
										<span class="applyNum">
										<img src="static/applyBtn.png" style="margin-right: 0.026315rem;">
											<span class="bold" style="display: flex; align-items: center;">{{ item.replycount }}</span>
										</span>
                  </div>
                </div>
                <div class="report_bt" v-if="item.report_url">
                  <a :href="item.report_url" target="_blank">
                    <img src="@/assets/report_bt.png" alt="">
                  </a>
                </div>
              </div>
            </div>
            <div class="luck-container" v-if="false">
              <div class="title">试用名单</div>
              <div class="swiper-container swiper-report">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="item in selected" :key="'sel'+item.id">
                    <div class="applyItem luck-list">
                      <img :src="item.avatar || require('@/assets/avatar-img.png')" class="portrait">
                      <div class="itemMiddle">
                        <span class="bold fontSize2">{{ item.nickname }}</span>
                        <span class="text-3"
                              style="height: 0.33rem; margin-top: 0.028947rem; color: #595959;">{{ item.reason }}</span>
                      </div>
                      <div class="itemRight">
												<span class="applyNum">
												<img src="static/applyBtn.png" style="margin-right: 0.026315rem;">
													<span class="bold" style="display: flex; align-items: center;">{{ item.replycount }}</span>
												</span>
                      </div>
                    </div>
                    <div class="report_bt" v-if="item.report_url">
                      <a :href="item.report_url" target="_blank">
                        <img src="@/assets/report_bt.png" alt="">
                      </a>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination" slot="pagination" style="bottom: 0.05rem;"></div>
              </div>
            </div>
            <div class="main-nav">
              <div class="nav-one" @click="tabId = item.id" :class="{'active' : item.id == tabId}"
                   v-for="item in tabs" :key="item.id">
                {{ item.name }}
                <div class="tab-line"></div>
              </div>
            </div>
            <div>
              <div class="detail_info" v-html="dataInfo.detail_info_pc" v-show="tabId == 1">
              </div>
              <div class="tab-item" v-show="tabId == 2">
                <ul class="apply-list">
                  <li class="apply-item apply-item-video" v-for="item in selected" :key="item.index">
                    <div class="video-box" v-if="item.video_img">
                      <img class="video-img" :src="item.video_img" alt="">
                      <a class="video-box-bg" :href="item.video_url" target="_blank">
                        <img class="video-img-btn" src="@/assets/img/video-player.png" alt="">
                      </a>
                    </div>
                    <div class="portrait-content">
                      <img class="portrait" :src="item.avatar || require('@/assets/avatar-img.png')"/>
                      <div class="item-middle">
                        <p class="bold fontSize2">{{ item.nickname }}</p>
                        <span style="margin: 0.078947rem 0 0.05rem;">{{ item.reason }}</span>
                        <span>{{ item.created_at }}</span>
                        <a v-if="item.report_url" class="report-btn" target="_blank"
                           :href="item.report_url">查看试用报告></a>
                        <div v-else-if="dataInfo.cate_id === '6' && state === 'end'" class="report-btn">申请成功</div>
                        <div v-else class="report-btn report-btn-disabled">试用报告敬请期待～</div>
                      </div>
                      <div class="item-right">
											<span class="apply-num" @click="dianzan(item.id)">
												<img style="margin-right: 0.026315rem;"
                             src="@/assets/img/applyBtn.png"/>
												<span style="display: flex; align-items: center;">{{ item.replycount }}</span>
											</span>
                      </div>
                    </div>

                  </li>
                  <li class="apply-item" v-for="item in applyList" :key="item.index">
                    <img class="portrait" :src="item.avatar || require('@/assets/avatar-img.png')"/>
                    <div class="item-middle">
                      <p class="bold fontSize2">{{ item.nickname }}</p>
                      <span style="margin: 0.078947rem 0 0.05rem;">{{ item.reason }}</span>
                      <span>{{ item.created_at }}</span>
                    </div>
                    <div class="item-right">
											<span class="apply-num" @click="dianzan(item.id)">
												<img style="margin-right: 0.026315rem;"
                             src="@/assets/img/applyBtn.png"/>
												<span style="display: flex; align-items: center;">{{ item.replycount }}</span>
											</span>
                    </div>
                  </li>
                  <li v-show="showLoadMore" class="load-more">加载中...</li>
                  <li v-show="!showLoadMore && !listFinished && !loading" class="load-more"
                      @click="loadMore">点击加载更多
                  </li>
                  <li v-show="listFinished" class="load-more load-no-more"
                      :class="{'height300': applyList.length === 0}">
                    没有更多了~
                    <div class="icon-no-more" v-if="applyList.length === 0">
                      <img src="@/assets/img/icon-no-more.png" alt="">
                    </div>
                  </li>
                </ul>
              </div>
              <div class="tab-item" v-show="tabId == 3">
                <div style="color:#000;" class="detail_info rule" v-html="dataInfo.detail_rule_pc">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-button" v-if="state == 'ing'">
        <div class="button" @click.prevent="showQrCode">申请试用 ></div>
      </div>
    </div>

    <!--页面底部固定提示-->
    <div class="bottom-tips" v-if="state === 'ing' || state === 'start'">
      <div class="main">
        <div class="text" v-if="state === 'ing'">
          免费获取产品/服务试用资格，点击右侧按钮立即申请 >
        </div>
        <div class="text" v-if="state === 'start'">
          试用开始立即获取消息通知，点击右侧按钮立即预约 >
        </div>
        <!--如果正在进行中显示申请按钮-->
        <div class="button" v-if="state === 'ing'" @click.prevent="showQrCode">申请试用 ></div>
        <!--如果未开始显示预约按钮-->
        <div class="button button-reserve" v-if="state === 'start'" @click.prevent="showQrCode">预约提醒 ></div>
      </div>
    </div>

    <reserve-dialog v-if="isReserveDialogShow" :reserveDialogType="reserveDialogType" :show.sync="isReserveDialogShow"></reserve-dialog>
  </div>
</template>

<script>
import "../../node_modules/swiper/dist/css/swiper.css";
import Swiper from "swiper";
import {mapState} from 'vuex';
import {EventBus} from "../event-bus.js";
import ReserveDialog from "@/components/reserveDialog.vue";

export default {
  name: 'page3',
  components: {ReserveDialog},
  data() {
    return {
      isReserveDialogShow: false, //预约弹窗
      reserveDialogType: 'ing', // 预约弹窗类型
      dataInfo: {},//接口数据信息
      applyList: [],//申请名单数据
      tabs: [{
        name: '商品详情',
        id: 1
      }, {
        name: '申请名单',
        id: 2
      }, {
        name: '试用规则 ',
        id: 3
      }],
      tabId: 1,
      p: 1,//申请名单分页
      showLoadMore: false,
      loading: false,
      listFinished: false,
      selected: [],
      report_url: '',
      countDownDatas: [],//数据倒计时
      countDownDatasStart: [],//数据开始时间
      allTryList: [],
      nextTid: 0,
      nextState: '',
      nextStyle: '',
      nextTryState: '',
      nextText: '',
      totalNum: 0,
      applyNum: 0,
      swiperReport: null,
      hasCoupon: false,
      couponTitle: '',
      couponImg: '',
    }
  },
  watch: {
    '$route': 'init'
  },
  computed: {
    ...mapState({
      state: 'applyState',
      stage: 'stage'
    })
  },
  created() {
    this.init()
  },
  mounted() {//给window添加一个滚动滚动监听事件
    var $tab = $("#tab");
    var $window = $(window);
    var $document = $(document);
    // window.onscroll = () => {
    // 	var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    // 	//var offsetTop = document.querySelector('#tab').offsetTop;
    // 	//var containerTop = document.querySelector('.container').offsetTop;
    // 	//console.log([scrollTop,scrollTop , (offsetTop+containerTop)])
    // 	if(scrollTop >= ($tab.offset().top)){
    // 		this.fixedTab = true;
    // 	}else{
    // 		this.fixedTab = false;
    // 	}
    // 	if ($window.scrollTop() + $window.height() == $document.height()) {
    // 		console.log('到底了');
    // 		// this.loadMore()
    // 	}
    // }
  },
  destroyed() {//离开该页面需要移除这个监听的事件
    if (this.swiperReport) {
      this.swiperReport.destroy();
    }
    window.onscroll = function () {
    };
  },
  methods: {
    init() {
      this.applyList = [];
      this.p = 1;
      this.dataInfo = {};
      this.tabId = 1,
          this.showLoadMore = false,
          this.loading = false,
          this.listFinished = false,
          this.refreshStatus();
      this.getData();
      this.getListData();
      this.getCoupon();
    },
    refreshStatus() {
      if (this.allTryList.length == 0) {
        this.axios.get('/campaigns-b/try/index.php?_c=home&_a=trylist').then((response) => {
          let listData = response.data.data, nowTime = new Date().getTime(), allTryList = [];
          allTryList = [...listData.history, ...listData.start, ...listData.wait];
          allTryList.map(item => {
            item.stage_index = Number(item.try_stage.replace(/[^0-9]/ig, ""));
            item.startTime = new Date(item.date_begin.replace(/-/g, "/")).getTime();
            item.endTime = new Date(item.date_end.replace(/-/g, "/")).getTime();
            if (item.startTime > nowTime) {
              item.applyState = 'start';
            }
            if (nowTime >= item.startTime) {
              item.applyState = 'ing';
            }
            if (nowTime >= item.endTime) {
              item.applyState = 'end';
            }
          });
          allTryList = this.$tool.sortKey(allTryList, 'stage_index').reverse();
          this.allTryList = allTryList
          // this.buss();
        })
            .catch(function (error) {
            });
      } else {
        // this.buss();
      }
    },
    /*buss() {
        let pId = -1;
        this.allTryList.map((item, index) => {
            if (item.id == this.$route.params.id) {
                pId = index;
                console.log('match ', this.$route.params.id, item, index);
            }
        });
        if (pId == (this.allTryList.length - 1)) {
            this.nextTryState = '';
            this.nextTid = '';
            this.nextState = '';
            this.nextStyle = 'background: url(./images/banner1_unsigned.png) top center/cover no-repeat;';
        } else if (pId > 0) {
            this.nextState = this.allTryList[pId + 1].applyState;
            this.nextTryState = this.allTryList[pId + 1].try_stage;
            this.nextTid = this.allTryList[pId + 1].id;
            this.nextStyle = '';
            console.log('next', this.nextTryState, this.nextTid);
        }
    },*/
    clickNext() {
      if (this.nextTid > 0) {
        this.$router.push({
          path: '/detail/' + this.nextTid
        })
      }
    },
    showQrCode() {
      this.isReserveDialogShow = true;
      this.reserveDialogType = this.state === 'ing'? 'jump': 'reserve';
      return;
      // EventBus.$emit('showQrCode',{
      // });
      // gioTrackAction('campaign0yuan_applyclick');
      this.$store.commit('showQrCode', 'http://www.dellemc-solution.com/campaigns/try/mobile-c/#/detail/' + this.$route.params.id);
    },
    dianzan(id) {
      this.$store.commit('showQrCode', 'http://www.dellemc-solution.com/campaigns/try/mobile-c/#/show/' + id);
    },

            gioPageSet() {
                const option = {
                    module:'eshop促销活动',
                    category1: '0元试用',
                    category2: '详情页',
                    title: `【${this.dataInfo.try_title}】详情页`
                }
                this.gioPageAction(option)
                this.$store.commit("setPageRecordUrl", "&linksourcemodule=eshop促销活动&category1=0元试用&category2=详情页");
            },

    getData() {
      this.axios.get('/campaigns-b/try/index.php?_c=detail&_a=get&tid=' + this.$route.params.id).then((response) => {
        var d = response.data.data;
        this.$store.commit('init', {
          startTime: (new Date(d.date_begin.replace(/-/g, '/')).getTime()),
          endTime: (new Date(d.date_end.replace(/-/g, '/')).getTime()),
          sqrCount: d.applytotal,
          stage: d.try_stage,
          selected: d.selected ? d.selected : [],
          report_url: d.report_url ? d.report_url : false,
          price: d.try_price
        });
        this.dataInfo = d
        this.selected = d.selected ? d.selected : [];

        const name_tab = this.selected.length > 0;
        if (name_tab) {
          this.tabs.map(item => {
            if (item.id === 2) {
              item.name = '试用报告';
            }
            return item;
          })
        } else {
          this.tabs.map(item => {
            if (item.id === 2) {
              item.name = '申请名单';
            }
            return item;
          })
        }
        // if (this.state === 'end' && this.dataInfo.cate_id === '6') {
        //   this.tabs.map(item => {
        //     if (item.id === 2) {
        //       item.name = '申请成功';
        //     }
        //     return item;
        //   })
        // }
        this.report_url = d.report_url ? d.report_url : false;
        if (d.next) {
          this.nextTid = d.next.id;
          this.nextText = d.next.try_stage;
          this.nextStyle = '';
        } else {
          this.nextTid = '';
          this.nextText = '';
          this.nextStyle = 'background: url(./images/page-detail-top-bg.png) top center/cover no-repeat;';
        }
        let date_begin1 = d.date_begin.split(" ")[0]
        this.countDownDatasStart = []
        date_begin1.split('-').forEach((item, index) => {
          if (index == 0) this.countDownDatasStart.push({name: '年', value: item})
          if (index == 1) this.countDownDatasStart.push({name: '月', value: item})
          if (index == 2) this.countDownDatasStart.push({name: '日', value: item})
        })
        this.formatTime()
        config.routerCallback(Object.assign({}, d, {pageName: 'detail'}));
        this.totalNum = d.total;
        this.applyNum = d.applytotal;
        if (d.selected.length > 1) {
          this.$nextTick(() => {
            this.initSwiperReport();
          });
        }
        this.gioPageSet();
      }).catch(function (error) { // 请求失败处理
      });
    },
    getListData() {
      return new Promise((resolve, reject) => {
        if (this.listFinished) {
          reject();
        }
        this.axios.get('/campaigns-b/try/index.php?_c=detail&_a=applylist&tid=' + this.$route.params.id + '&p=' + this.p + '&size=' + config.pageSize).then((response) => {
          if (this.p == 1) {
            this.applyList = response.data.data;
          } else if (response.data.data && response.data.data.length > 0) {
            this.applyList = this.applyList.concat(response.data.data);
          }
          if (this.p >= response.data.msg) {
            this.listFinished = true;
            this.showLoadMore = false;
            return new Promise(() => {
            });  //中断promise链
          }
          this.p++;
          resolve();
        }).catch(function (error) { // 请求失败处理
          console.log(error);
        });
      })
    },
    loadMore() {
      let that = this;
      if (this.loading === true) return;
      this.loading = true;
      this.showLoadMore = true;
      this.getListData().then(() => {
        //return;
        that.showLoadMore = false;
        setTimeout(() => {
          //$(document).scrollTop(100);
          that.loading = false;
        }, 100)
      }).catch(() => {
        that.showLoadMore = false;
      });
    },
    formatTime() {
      var nowTime = new Date().getTime();
      var date_end = this.getTimestamp(this.dataInfo.date_end);
      var lefttime = parseInt(date_end - nowTime / 1000);
      var d = parseInt(lefttime / (24 * 60 * 60));
      var h = parseInt(lefttime / (60 * 60) % 24);
      var m = parseInt(lefttime / 60 % 60);
      var s = parseInt(lefttime % 60);
      if (lefttime <= 0) {
        d = h = m = s = 0;
      }
      this.countDownDatas = [];
      this.countDownDatas.push({
        name: '天',
        value: d
      })
      this.countDownDatas.push({
        name: ':',
        value: h
      })
      this.countDownDatas.push({
        name: ':',
        value: m
      })
      this.countDownDatas.push({
        name: '',
        value: s
      })
      if (lefttime <= 0) {
        this.$store.commit('setApplyState', 'end');
        return;
      }
      this.time = setTimeout(() => {
        this.formatTime();
      }, 1000)
    },
    getTimestamp(date) {
      if(!date){
        return;
      }
      date = new Date(date.replace(/-/g, '\/'));
      date = date.getTime();
      return Math.round(date / 1000);
    },
    initSwiperReport() {
      if (this.swiperReport) return;
      this.swiperReport = new Swiper('.swiper-report', {
        loop: true,
        speed: 600,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
        },
      });
    },
    getCoupon() {
      this.axios.get('/campaigns-b/try/index.php?_c=detail&_a=coupon&tid=' + this.$route.params.id).then((response) => {
        if (response.data.code == 200 && response.data.data.coupon_title) {
          this.hasCoupon = true;
          this.couponTitle = response.data.data.coupon_title;
          this.couponImg = response.data.data.coupon_image;
        }
      }).catch(function (error) { // 请求失败处理
      });
    },
  },
}
</script>

<style scoped lang="scss">
.page-banner {
  width: 100%;
  height: 350px;
  background-image: url(~@/assets/img/page-home-banner.png);
  background-size: auto 430px;
  background-position: center bottom;
  border-bottom: 2px solid #8d766d;

  .page-banner-content {
    width: 800px;
    margin: 0 auto;
    height: auto;
    display: flex;
    justify-content: space-between;

    .content-left {
      justify-items: flex-end;

      .left-img {

        width: 230px;
        height: 230px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        position: relative;
        left: 40px;
        top: -30px;

        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .note-img {
        width: 290px;
        height: 290px;
        left: 9px;
        top: -95px;
      }

      .left-img-bg {
        position: relative;
        bottom: 46px;
        left: -123px;
        height: 87.5px;
        width: 170%;
      }

      .left-img-bg-img {
        height: 83.5px;
        width: 100%;
      }
    }

    .content-right {

      .page-title {
        width: 100%;

        img {
          width: 100%;
        }
      }

      .page-title-70 {
        img {
          width: 70%;
        }
      }

      .page-title-right {
        width: 100%;
        text-align: center;
      }

      .right-title {
        font-size: 27px;
        line-height: 36px;
        color: #fff;
        text-align: center;
        font-weight: bold;

        span {
          color: #db433d;
        }
      }

      .right-title-new {
        font-size: 27px;
        line-height: 36px;
        color: #e6dbcd;
        text-align: center;
        font-weight: bold;
        margin-top: 20px;
      }

      .lijishenqing {
        width: 170px;
        height: 38px;
        font-size: 23px;
        margin: 12px auto 0;
        color: #fff;
        line-height: 38px;
        text-align: center;
        background: url(~@/assets/img/lijishenq.png) center center/cover no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }

      .lijishenqing-no {
        background: linear-gradient(0deg, #0C73D8 1%, #0C73D8);
        /*background: #6a6a6a;
        cursor: not-allowed;*/
      }

      .right-text {
        font-size: 16px;
        text-align: center;
        line-height: 25px;
        color: #fff;
        margin: 20px auto 40px;
      }

      .right-last {
        position: relative;
        width: 98%;
        height: 66px;
        margin: 0 auto;
        padding: 0 5.9%;
        display: flex;
        align-items: center;
        justify-content: space-around;

        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }

        .line {
          position: absolute;
          left: 5.9%;
          top: 32px;
          width: 88.2%;
          height: 1px;
          background: #fff;
        }

        .last-one {
          position: relative;
          width: 8px;
          height: 8px;
          margin-top: 28px;
          background: #fff;
          border-radius: 50%;

          p {
            position: absolute;
            top: 15px;
            left: -56px;
            font-size: 14px;
            color: #fff;
            line-height: 16px;
            text-align: center;
            width: 120px;
          }

          .time {
            top: -20px;
          }
        }
      }

      .right-num {
        margin: 10px auto 27px;
        font-size: 12px;
        color: #fff;
        align-items: center;
        line-height: 12px;
      }

      .right-last-con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0 15px;
      }

      .right-last-title {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        letter-spacing: 1px;
        color: #ffffff;
        line-height: 28px;

        span {
          font-size: 26px;
          color: #db433d;
          font-weight: bold;
        }
      }

      .right-last-time {
        width: 270px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ffffff;
        border-radius: 5px;

        .time-one {
          height: 27px;
          width: auto;
          display: flex;
          justify-content: center;
          align-items: center;

          &:last-child {
            border-right: none;
          }
        }

        p {
          text-align: center;
          color: #ffffff;
          line-height: 29px;

          &.num {
            width: 51px;
            font-size: 21px;

          }

          &.start-num {
            width: auto;
            font-size: 21px;
            padding: 0 8px;
          }
        }

        span {
          width: 1px;
          height: 27px;
          border-right: 1px dashed #ffffff;
          opacity: 0.7;
        }
      }

      .right-last-coupon {
        margin: 0 auto 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        padding-top: 20px;

        .right-last-coupon-infor {
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          margin-left: 40px;
          text-align: center;
          line-height: 25px;
        }

        img {
          width: 83px;
          height: 83px;
        }
      }
    }
  }
}

.page-banner .page-banner-content .content-left,
.page-banner .page-banner-content .content-right {
  width: 360px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
}

.page-detail {
  width: 100%;
  height: auto;
  min-height: 100vh;

}

.page-bg {
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: url(~@/assets/img/page-home-bg.png) no-repeat center center/cover;
}

.page {
  width: 98%;
  max-width: 771px;
  padding: 30px 0 100px;
  position: relative;
}

.page .logo {
  width: 149px;
  position: absolute;
  top: 30px;
  left: 0;
}

.page .banner {
  position: absolute;
  top: 88px;
  left: 0;
  width: 100%;
  height: 192px;
  display: flex;
  justify-content: space-between;
}

.page .banner .banner-left {
  width: 43%;
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}

.page .banner .banner-left img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

.page .banner .banner-right {
  margin: 12px 52px 0 0;
  width: 308px;
}

.page .banner .banner-right img {
  width: 100%;
}

.page .container {
  width: 100%;
}

.page .container .content-title {
  margin: 0 auto;
  width: 93.7%;
  height: auto;
  padding-bottom: 10px;
  background: url(~@/assets/img/page-detail-top-bg1.png) top center no-repeat;
  background-size: 100%;

  .number-con {
    display: flex;
    padding: 10px 0 0 10px;

    .current-con, .next-con {
      position: relative;
      width: 240px;
      height: 40px;
      line-height: 40px;
      margin-right: 30px;
      text-align: center;
      border-radius: 20px;
      background-color: #b11c16;
      color: #ffffff;
      font-size: 16px;
    }

    .next-con {
      cursor: pointer;
    }

    .icon-huo {
      position: absolute;
      right: -8px;
      top: -8px;
      display: block;
      width: 37px;
      height: 47px;
      background: url(~@/assets/img/icon-huo.png) no-repeat center center / cover;
    }
  }

  .content-box {
    display: flex;
    justify-content: center;
    margin-top: 15px;

    .title-describe {
      width: calc(100% - 200px);

      .title {
        margin: 21px 0 9px;
        padding-right: 24px;
        font-size: 26px;
        text-align: left;
        color: #000000;
        line-height: 27px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .subtitle {
        margin-bottom: 9px;
        padding-right: 24px;
        font-size: 14px;
        text-align: left;
        color: #595959;
        line-height: 27px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .price-number {
      margin-top: 10px;

      .price {
        display: flex;
        align-items: flex-end;
        font-size: 21px;
        color: #b11c16;
        line-height: 30px;

        & > p {
          font-size: 45px;
          font-weight: bold;
          line-height: 45px;
        }

        .old {
          margin-left: 10px;
          text-decoration: line-through;
          color: #6D6D6D;
        }
      }

      .number {
        font-size: 15px;
        text-align: center;
        color: #595959 !important;
        line-height: 24px;
      }
    }

  }
}

.page .container .content-main {
  width: 100%;
  margin: 0;
  padding: 10px 8px;
  background: #D2E8FF;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 50%);
  border-radius: 10px;
}

.page .container .content-main .main {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.main .right-last-coupon {
  margin: 5px 5px 8px 33px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.main .right-last-coupon p {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
}

.main .right-last-coupon img {
  width: 78px;
  height: 78px;
}

.main .main-top-time {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 33px;
  min-height: 61px;
}

.main .main-top-time .left-time {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
}

.main .main-top-time .left-time .time {
  width: 248px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: url(~@/assets/img/page-detail-time-bg.png) center center/cover no-repeat;
  background-size: 100% 100%;
}

.main .main-top-time .left-time .time-one {
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .main-top-time .left-time .time .time-one:first-child {
  margin-right: 12px;
}

.main .main-top-time .left-time .time .time-one:first-child span {
  width: 35px;
  font-size: 21px;
  border-right: 1px solid rgba(0, 0, 0, 0.25);
}

.main .main-top-time .left-time .time .time-one span {
  padding: 0 3px;
  font-size: 23px;
  text-align: center;
  font-weight: bold;
  color: #0C73D8;
  line-height: 23px;
}

.main .main-top-time .left-time .time2 {
  width: 332px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: url(~@/assets/img/page-detail-time-bg.png) center center/cover no-repeat;
  background-size: 100% 100%;
}

.main .main-top-time .left-time .time2 .time-one span {
  font-size: 23px;
  min-width: 45px;
  text-align: center;
  font-weight: bold;
  color: #0C73D8;
  line-height: 23px;
  border-right: 1px solid rgba(0, 0, 0, 0.25);
}

.main .main-top-time .left-time .time2 .time-one span:first-child {
  min-width: 53px;
  padding: 0 10px;
}

.main .main-top-time .left-time .time2 .time-one:last-child span:last-child {
  border-right: none;
}

.main .main-top-time .left-time .time span:last-child {
  border-right: none;
}

.main .main-top-time .main-button {
  width: 160px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  color: #000000;
  line-height: 25px;
  border-radius: 7px;
  background: url(~@/assets/img/page-detail-main-button.png);
  background-size: 100% 100%;
}

.main .main-top-time .main-button img {
  width: 16px;
  margin-left: 9px;
}

.main .main-nav {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: url(~@/assets/img/page-detail-tab-bg1.png) top center no-repeat;
  background-size: 100% 100%;
}

.main .main-nav .nav-one {
  position: relative;
  width: 130px;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  color: #BDDEFF;
  line-height: 54px;
}

.main .main-nav .nav-one .tab-line {
  display: none;
  position: absolute;
  bottom: 1px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #D6EAFF;
  border-radius: 2px;
}

.main .main-nav .nav-one.active {
  font-size: 23px;
  font-weight: 600;
  color: #FFFFFF;
}

.main .main-nav .nav-one.active .tab-line {
  display: block;
}

.main .detail_info {
  width: 100%;
  height: auto;
  background: #FFF;
  border: 1px dashed #0248D7;
  border-top: none;

  &.rule {
    border-radius: 10px;
    border: none;
  }
}

.main .tab-item {
  /*width: 96.6%;*/
  padding: 20px;
  border: 1px dashed #0248D7;
  border-top: none;

}

.main .tab-item .apply-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 0.052631rem;
  padding-left: 0.131578rem;
  padding-right: 0.263157rem;
  margin-bottom: 8px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 0px rgba(12, 115, 216, 0.53);

  &.apply-item-video {
    padding: 0;

    .video-box {
      position: relative;
      width: 186px;
      min-height: 130px;

      .video-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .video-box-bg {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .4);

        .video-img-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 50px;
        }
      }
    }

    .portrait-content {
      flex: 1;
      display: flex;
      justify-content: space-between;
      position: relative;
      min-width: calc(100% - 186px);
      padding: 0.052631rem;
      padding-left: 0.131578rem;
      padding-right: 0.263157rem;
    }
  }
}

.apply-item .portrait {
  width: 0.289473rem;
  height: 0.289473rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.apply-item .item-right {
  position: absolute;
  top: 0.052631rem;
  right: 5px;
  width: 60px;
}

.container-button .button {
  width: 170px;
  height: 38px;
  font-size: 23px;
  margin: 12px auto 0;
  color: #fff;
  line-height: 38px;
  text-align: center;
  background: url(~@/assets/img/lijishenq.png) center center/cover no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.item-middle {
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: #000000;
  padding-left: 0.08421rem;
  font-size: 0.078947rem;

  .report-btn {
    cursor: pointer;
    width: 145px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    margin: 10px auto;
    background: linear-gradient(0deg, #820b06 1%, #b50f08);
    color: #fff;
    font-size: 16px;
  }

  .report-btn-disabled {
    width: auto;
    padding: 0 20px;
    background: #ccc;
    cursor: not-allowed;
  }
}

.item-middle > p {
  width: 80%;
  height: 20px;
  font-size: 18px;
  line-height: 20px;
  overflow: hidden;
}

.item-middle > span {
  color: #595959;
}

.apply-num {
  color: #FE5638;
  display: flex;
  font-size: 13px;
  line-height: 13px;
  cursor: pointer;
  align-items: flex-end;
}

.apply-num img {
  width: 0.131578rem;
}

.load-more {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  color: #0C73D8;
  line-height: 34px;
  letter-spacing: 5px;
  height: 100px;

  &.load-no-more {
    flex-direction: column;
  }

  &.height300 {
    height: 300px;
  }

  .icon-no-more {
    width: 176px;
    margin-top: 10px;

    img {
      width: 100%;
    }
  }
}

.rule {
  padding: 0.210526rem;
  font-size: 16px;
  line-height: 30px;
  color: #595959;
}

.rule img {
  max-width: 100%;
}

.apply-show {
  color: #000000 !important;
}

.applyItem {
  display: flex;
  justify-content: space-between;
  background-color: #fceced;
  border-radius: 0.052631rem;
  margin-bottom: 0.026315rem;
  padding: 0.052631rem;
  padding-left: 0.131578rem;
  padding-right: 0.263157rem;
  position: relative;
}

.applyItem .portrait {
  width: 0.289473rem;
  height: 0.289473rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.applyItem .itemRight {
  position: absolute;
  top: 0.052631rem;
  left: 87%;
}

.applyNum {
  color: #ea3627;
  display: flex;
  align-items: center;
}

.applyNum img {
  width: 0.131578rem;
}

.luck-container {
  position: relative;
  padding: 20px 40px 0;
}

.swiper-report {
  padding-bottom: 0.2rem;
}

.luck-container .title, .process .title {
  margin-bottom: 10px;
  color: #b11c16;
  font-size: 20px;
  font-weight: bold;
}

.luck-list {
  background-color: rgba(0, 0, 0, 0);
  padding-left: 0;
  padding-right: 0;
}

.luck-list .itemRight {
  right: 0;
}

.luck-list .itemRight .applyNum {
  justify-content: flex-end;
  margin-right: .1rem;
}

.report_bt {
  margin-top: 10px;
  text-align: center;
}

.report_bt a {
  display: block;
}

.report_bt a img {
  width: 1rem;
}

.itemMiddle {
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 0.08421rem;
  font-size: 0.078947rem;
}

.text-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bottom-tips{
  background-color: rgba(0,0,0,0.5);
  height: 40px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .main{
    display: flex;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    .text{
      font-size: 14px;
      color: #fff;
      line-height: 20px;
      margin-right: 20px;
    }
    .button{
      width: 130px;
      height: 30px;
      font-size: 14px;
      color: #fff;
      line-height: 30px;
      text-align: center;
      background: url(~@/assets/img/lijishenq.png) center center/cover no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .button-reserve{
      // 背景色是渐变蓝
      background: linear-gradient(0deg, #0C73D8 1%, #0C73D8);
    }
  }
}
</style>
